import React from 'react';
import { FieldCurrencyInput } from '../../../../components';
import css from './EditListingInfoForm.module.css';
import appSettings from '../../../../config/settings';
const ShippingFeeInputField = ({ intl, priceValidators, marketplaceCurrency }) => {
  return (
    <FieldCurrencyInput
      id="shippingPriceInSubunitsOneItem"
      name="shippingPriceInSubunitsOneItem"
      className={css.formFld}
      label={intl.formatMessage({ id: 'EditListingDeliveryForm.shippingOneItemLabel' })}
      placeholder={intl.formatMessage({ id: 'EditListingDeliveryForm.shippingOneItemPlaceholder' })}
      currencyConfig={appSettings.getCurrencyFormatting(marketplaceCurrency)}
      validate={priceValidators}
    />
  );
};

export default ShippingFeeInputField;
